module.exports = __webpack_public_path__ + "static/media/Ana Bello-Elliott.3906a11b.png";